import { benefitItems } from '@/mocks/seoContent';

export default function BenefitsSection() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-accent-600 bg-accent-100 rounded-full px-3 py-1 mb-3">
            Why Choose Superbuy Spreadsheet
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-2">
            Shop Smarter, Not Harder
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            A quality Superbuy Spreadsheet transforms your shopping experience with these proven advantages
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {benefitItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}